var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "div"
  }, [_c("editor", {
    ref: "editor",
    staticClass: "pre-doc",
    attrs: {
      "tool-fixed": false,
      "is-document": true,
      disabled: true,
      "default-val": _vm.data
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };